/* gw-pdp-q4.js — Q4 Print Options CLARITY PASS (2026-09-17).
 *
 * Everything here is read-only DOM sugar layered on top of the existing PDP: it never
 * touches size-unselected.js or the inline gate in sections/main-product.liquid, and it
 * never blocks or delays add-to-cart (every entry point is wrapped in try/catch).
 *
 * Two jobs, both because the theme replaces / resets DOM in ways plain Liquid can't track:
 *
 * 1) Size decision heading ("Size: choose one" in red -> "Size: L") — Liquid can't drive
 *    this because size-unselected.js force-unchecks every Size radio ~200ms after load
 *    (a plain client-side hack, no native `change` event fires), so the server-rendered
 *    `option.selected_value` for Size does not reflect what the shopper actually sees.
 *    We read the checked radio live instead, mirroring size-unselected.js's own selector
 *    (name*="Size" / name*="size") so the two stay in lockstep by construction.
 *
 * 2) "Add to cart · $price" on the submit button — product-form.js / product-info.js
 *    rewrite that button's text on every sold-out / unavailable / re-enabled transition
 *    (toggleSubmitButton() in product-form.js always resets it to window.variantStrings.addToCart
 *    when re-enabling), so a static Liquid label would go stale the instant a shopper
 *    changes any option. We re-apply the suffix every time, after the theme's own update.
 *
 * Re-render survival: product-info.js replaces the ENTIRE <variant-selects> node on every
 * option change (HTMLUpdateUtility.viewTransition in assets/global.js) — any listener bound
 * directly to elements inside it is destroyed. buy-buttons.liquid (where this file's <script
 * src> tag lives) is never part of that replaced region, so this file itself only loads/runs
 * once per page view; it stays alive across variant changes and re-applies via:
 *   - the theme's own pub/sub event (PUB_SUB_EVENTS.variantChange, published at the end of
 *     product-info.js's handleUpdateProductInfo — fires on every option change);
 *   - a MutationObserver on document.body (childList+subtree+the `checked` attribute),
 *     the same belt-and-suspenders pattern size-unselected.js already uses, to catch the
 *     size-unselected.js force-uncheck (which sets .checked=false without a change event)
 *     and the view-transition swap itself;
 *   - a delegated `change` listener on document for the ordinary case (a shopper actually
 *     clicking a size).
 */
(function () {
  if (window.__gwPdpQ4Init) return;
  window.__gwPdpQ4Init = true;

  function isSizeRadio(el) {
    if (!el || el.tagName !== 'INPUT' || el.type !== 'radio') return false;
    var name = el.name || '';
    return name.indexOf('Size') !== -1 || name.indexOf('size') !== -1;
  }

  function updateSizeHeadings() {
    var mains = document.querySelectorAll('product-info[id^="MainProduct-"]');
    for (var i = 0; i < mains.length; i++) {
      var main = mains[i];
      var vals = main.querySelectorAll('[data-gwq4-sizeval]');
      if (!vals.length) continue;

      var radios = main.querySelectorAll('input[type="radio"][name*="Size"], input[type="radio"][name*="size"]');
      var checked = null;
      for (var r = 0; r < radios.length; r++) {
        if (radios[r].checked) { checked = radios[r]; break; }
      }

      for (var v = 0; v < vals.length; v++) {
        var span = vals[v];
        // write ONLY on change: this runs from a MutationObserver on <body>, and assigning the
        // same textContent still replaces the text node = a mutation = an endless update loop
        var want = checked ? ': ' + checked.value : ': choose one';
        if (span.textContent !== want) span.textContent = want;
        if (span.classList.contains('gwq4-todo') === !!checked) span.classList.toggle('gwq4-todo', !checked);
      }
    }
  }

  function readDisplayedPrice(main) {
    var section = main.getAttribute('data-section');
    var priceEl = section ? document.getElementById('price-' + section) : null;
    if (!priceEl) priceEl = main.querySelector('[id^="price-"]');
    if (!priceEl) return null;

    var priceBox = priceEl.querySelector('.price') || priceEl;
    var onSale = priceBox.classList && priceBox.classList.contains('price--on-sale');
    var target = onSale
      ? priceBox.querySelector('.price__sale .price-item--sale')
      : priceBox.querySelector('.price__regular .price-item--regular');
    if (!target) target = priceBox.querySelector('.price-item--regular, .price-item--sale');
    if (!target) return null;

    var text = target.textContent.replace(/\s+/g, ' ').trim();
    return text || null;
  }

  function updateAddToCartLabels() {
    var mains = document.querySelectorAll('product-info[id^="MainProduct-"]');
    for (var i = 0; i < mains.length; i++) {
      var main = mains[i];
      var buttons = main.querySelectorAll('.product-form__submit');
      for (var b = 0; b < buttons.length; b++) {
        var btn = buttons[b];
        if (btn.hasAttribute('disabled')) continue; // sold out / unavailable — never touch

        var label = btn.querySelector('span');
        if (!label) continue;

        var base = (window.variantStrings && window.variantStrings.addToCart) || label.dataset.gwq4Base || 'Add to cart';
        if (!label.dataset.gwq4Base) label.dataset.gwq4Base = base;

        var price = readDisplayedPrice(main);
        var wantLabel = price ? (base + ' \u00b7 ' + price) : base;
        if (label.textContent.replace(/\s+/g, ' ').trim() !== wantLabel) label.textContent = wantLabel;
      }
    }
  }

  function updateAll() {
    try { updateSizeHeadings(); } catch (e) {}
    try { updateAddToCartLabels(); } catch (e) {}
  }

  // Ordinary case: a shopper clicks a size (native `change` fires).
  document.addEventListener('change', function (e) {
    if (isSizeRadio(e.target)) updateAll();
  });

  // The theme's own "a variant finished re-rendering" signal.
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { updateAll(); });
    }
  } catch (e) {}

  // Belt-and-suspenders: size-unselected.js flips `.checked` programmatically (no `change`
  // event), and view-transition swaps whole nodes — both are attribute/DOM mutations only.
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; updateAll(); }, 0);
  }
  try {
    var observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked'] });
  } catch (e) {}

  function init() {
    updateAll();
    setTimeout(updateAll, 300); // after size-unselected.js's ~200ms force-uncheck
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
